@if (label != null) {
  <div class="label-wrapper">
    <label>{{label}}</label>
    <app-warning-star [type]="warningLevel"></app-warning-star>
  </div>
}
<form [formGroup]="form"
  class="dropzone"
  [ngClass]="{'disabled': disable} "
  [attr.disabled]="disable"
  (fileDrop)="onFileDropped($event)"
  (click)="file.click()"
  data-cy="drag-and-drop-dropzone"
  appDragAndDrop>
  <input #file
    formControlName="fileDropInput"
    type="file"
    id="fileDropInput" multiple
    (change)="change($event)"
    data-cy="drag-and-drop-input">
  <div class="drop-area">
    <p class="drop-message" data-cy="drag-and-drop-message">Drag files to attach, or browse</p>
    <p class="drop-message-info" data-cy="drag-and-drop-message-info">{{uploadAreaLabel}}</p>
  </div>
</form>

